/**
 * SchemaError is used when a schema is not valid for
 * the context.
 */
export class SchemaItemError extends Error {
    /**
     *
     * @param message Error message
     */
    constructor(message: string) {
        super(message)
        this.name = "SchemaItemError"
    }
}
